module.exports = __webpack_public_path__ + "static/img/banner_pohone3.5ef8df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner_pohone3.png
// module id = 79
// module chunks = 1 4